import React, { useEffect, useState } from 'react'
import { Alert, Box, CircularProgress, Container } from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'
import api from '../services/api'
import ServiceProProfileView from '../components/ServiceProProfileView'

export default function ServiceProRequestDetail() {
    const { requestId } = useParams()
    const navigate = useNavigate()
    const [provider, setProvider] = useState(null)
    const [error, setError] = useState('')

    useEffect(() => {
        let active = true

        api.get(`/service-pros/requests/${requestId}/matches`)
            .then((response) => {
                if (!active) return
                const data = response.data?.data || {}
                const selectedId = Number(data.selected_provider_id)
                const selected = (data.providers || []).find((item) => Number(item.id) === selectedId)

                if (!selected) {
                    setError('The selected Service Pro for this request is no longer available.')
                    return
                }

                setProvider(selected)
            })
            .catch((requestError) => {
                if (active) setError(requestError.response?.data?.message || 'This Service Pro request could not be loaded.')
            })

        return () => { active = false }
    }, [requestId])

    if (error) {
        return <Container maxWidth="md" sx={{ py: 6 }}><Alert severity="error">{error}</Alert></Container>
    }

    if (!provider) {
        return <Box sx={{ minHeight: 500, display: 'grid', placeItems: 'center' }}><CircularProgress /></Box>
    }

    return (
        <Container maxWidth="md" sx={{ py: 5 }}>
            <ServiceProProfileView
                provider={provider}
                requestId={requestId}
                onBack={() => navigate('/service-pros')}
            />
        </Container>
    )
}
